import i18next from 'i18next'
import { CalendarPickerView } from '@mui/x-date-pickers'

/**
 * TODO: Once energy-management is refactored from a separate package to a directory inside portal/apps/src/Libs, reuse
 * utilities found in src/Libs/systemCharts/utils/date-handling.ts which share a lot of code with this helper.
 */
export type DashboardChartView = 'day' | 'week' | 'month' | 'year'

export const getDateFormat = (view: DashboardChartView): string => {
  switch (view) {
    case 'year':
      return 'YYYY'
    case 'month':
      return i18next.t('common.format.dateWithoutDay')
    case 'week':
      return i18next.t('common.format.week-year-format')
    case 'day':
      return i18next.t('common.format.date')
    default:
      return i18next.t('common.format.date')
  }
}

export const getDateViews = (view: DashboardChartView): CalendarPickerView[] => {
  switch (view) {
    case 'year':
      return ['year']
    case 'month':
      return ['year', 'month']
    case 'day':
      return ['year', 'month', 'day']
    case 'week':
    default:
      return ['year', 'month', 'day']
  }
}
